import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

const KEY = "ege_scam_notice_v1";

/* Entry notice (NEXT-style): black panel over a dimmed page, shown once per browser session. */
export default function ScamNotice() {
  const nav = useNavigate();
  const [open, setOpen] = useState(() => {
    try { return !sessionStorage.getItem(KEY); } catch { return true; }
  });

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  const dismiss = () => {
    try { sessionStorage.setItem(KEY, "seen"); } catch {}
    setOpen(false);
  };

  if (!open) return null;

  return createPortal(
    <div
      data-testid="scam-notice"
      role="dialog"
      aria-modal="true"
      aria-labelledby="scam-notice-title"
      className="fixed inset-0 z-[90] flex items-center justify-center p-4 sm:p-8 bg-black/55 backdrop-blur-[2px] menu-overlay-in"
    >
      <div className="w-full max-w-5xl bg-[#0A0A0A] text-white p-7 sm:p-10 lg:p-12 max-h-[92vh] overflow-y-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-4">
            <h2 id="scam-notice-title" className="font-serif font-semibold text-lg sm:text-xl leading-snug tracking-wide">
              IMPORTANT NOTICE: BEWARE OF FRAUDULENT INDIVIDUALS CLAIMING TO REPRESENT EGE MODELS
            </h2>
            <p className="mt-6 text-sm leading-relaxed text-white/80">
              There have been reports of individuals falsely presenting themselves as scouts, agents or recruiters for
              Ege Models on social media and messaging apps. To protect yourself,{" "}
              <strong className="text-white">do not engage with anyone claiming to be affiliated with Ege Models</strong>{" "}
              unless they have been verified through our official channels.
            </p>
          </div>

          <div className="lg:col-span-4">
            <p className="text-sm leading-relaxed text-white/80">
              Ege Models only reaches out from{" "}
              <a href="mailto:info@egemodels.com" data-testid="scam-notice-email" className="text-white font-semibold underline underline-offset-4">
                info@egemodels.com
              </a>
              . Every genuine approach from our team is confirmed from this address — if you have not received that
              email, it is not us.
            </p>
            <p className="mt-5 text-sm leading-relaxed text-white/80">
              Ege Models will <strong className="text-white">NEVER request nude or undergarment photos</strong> and will{" "}
              <strong className="text-white">NEVER ask for any payment</strong> as part of our process.
            </p>
            <p className="mt-5 text-sm leading-relaxed text-white/80">
              <strong className="text-white">Your safety comes first.</strong> If you receive a suspicious message,{" "}
              <a href="mailto:info@egemodels.com" className="text-white underline underline-offset-4">contact us immediately</a>.
            </p>
          </div>

          <div className="lg:col-span-4 flex flex-col justify-end gap-3 lg:pl-6">
            <button
              type="button"
              data-testid="scam-notice-go"
              onClick={dismiss}
              className="w-full border border-white/70 hover:bg-white hover:text-black transition-colors py-3.5 text-xs sm:text-sm font-semibold tracking-[0.18em] uppercase"
            >
              Go to site
            </button>
            <button
              type="button"
              data-testid="scam-notice-apply"
              onClick={() => { dismiss(); nav("/apply"); }}
              className="w-full border border-white/70 hover:bg-white hover:text-black transition-colors py-3.5 text-xs sm:text-sm font-semibold tracking-[0.18em] uppercase"
            >
              Get scouted
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
